(function () {
  "use strict";

  const STORAGE_KEY = "theme-preference";
  const HTML = document.documentElement;

  function getPreference() {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "dark" || stored === "light") return stored;

    return "light";
  }

  function applyTheme(theme) {
    HTML.setAttribute("data-theme", theme);

    document.querySelectorAll(".dark-mode-toggle").forEach(function (btn) {
      btn.setAttribute(
        "aria-label",
        theme === "dark" ? "Ativar modo claro" : "Ativar modo escuro"
      );
    });
  }

  function toggleTheme() {
    var current = HTML.getAttribute("data-theme") || "light";
    var next = current === "dark" ? "light" : "dark";
    localStorage.setItem(STORAGE_KEY, next);
    applyTheme(next);
  }

  applyTheme(getPreference());

  function init() {
    document.querySelectorAll(".dark-mode-toggle").forEach(function (btn) {
      btn.addEventListener("click", toggleTheme);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();